const getters = {
  scShifts: state => state.sc_shifts,
  scShift: state => state.sc_shift,
  scShiftFilters: state => state.sc_shift_filters,
}

export default getters;
